import confirmation from './confirmation.json';
import loadingPage from './loading-page.json';

export default {
  'update-identity-document': {
    ...confirmation,
    ...loadingPage,
    ine_no_expired: 'Tu INE no ha expirado, aún cuenta con validez, te estamos redirigiendo',
    errors: {
      request_update_ine: 'Se produjo un error al intentar procesar la solicitud de actualización del INE',
    },
  },
};
